module.exports = "<ng-progress></ng-progress>\r\n<router-outlet></router-outlet>\r\n<p-growl life=\"4000\"></p-growl>"